import { useCallback } from "react";
import { FlatList } from "react-native";
import { Spacings, View } from "react-native-ui-lib";
import Sale, { SalePayment } from "../../../../utilities/data/model/Sale";
import { formatDateToCalendar } from "../../../../utilities/date/format-date";
import { moneyToFormattedString } from "../../../../utilities/money";
import {
  Button,
  Divider,
  PayTypeToIcon,
  Text,
} from "@towersystems/roam-common-native";
export interface SalePaymentsSummaryProps {
  sale: Sale;
  onRefundClick?: (payment: SalePayment) => void;
}

export const SalePaymentSummary = ({
  onRefundClick,
  sale,
}: SalePaymentsSummaryProps) => {
  const renderItem = useCallback(({ item }: { item: SalePayment }) => {
    const canRefund =
      onRefundClick &&
      item.state == "Settled" &&
      item.amount >= 0 &&
      item.paymentTypeId !== "2";

    return (
      <View row>
        <View
          style={{
            marginRight: 20,
            width: 47,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PayTypeToIcon payType={item.paymentTypeId} />
        </View>
        <View flex>
          <Text variant="heading1">{item.name}</Text>
          <Text variant="heading4" color="subdued">
            {formatDateToCalendar(item.paymentDate)}
          </Text>
          <Text variant="heading4" color="subdued">
            {item.state}
            {item.transactionId ? ` / ${item.transactionId}` : ""}
          </Text>
        </View>
        <View row style={{ alignItems: "center" }}>
          <Text variant="heading1">{moneyToFormattedString(item.amount)}</Text>
          {canRefund && (
            <Button
              onPress={() => onRefundClick(item)}
              style={{ marginLeft: Spacings.s4 }}
              label="Refund"
              isDestructive
            ></Button>
          )}
        </View>
      </View>
    );
  }, []);

  return (
    <FlatList
      scrollEnabled={true}
      ItemSeparatorComponent={Divider}
      data={sale.payments}
      renderItem={renderItem}
    ></FlatList>
  );
};
